import React, { useState, useEffect } from "react";
import ReSelect from "react-select";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import Input from "../reactive-input/index";
import valid from "../../assets/success/icon.png";
import { onSelectEvent } from "../reactive-events/onSelect";

const customStyles = {
  control: (provided, state) => ({
    display: "flex",
    width: "84%",
    height: "90%",
    marginLeft: "1%",
    outline: "none",
    border: "none",
    backgroundColor: state.isDisabled ? "#f5f5f5" : "#ffffff",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    pointerEvents: state.isDisabled ? "none" : "auto",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    pointerEvents: state.isDisabled ? "none" : "auto",
  }),
  container: (provider, state) => {
    const { isFocused, isDisabled } = state;
    let _slctd = state.getValue().length === 1 ? state.getValue()[0] : {};
    let border = _slctd.value
      ? {
          border: "solid 2px #007176",
          background: `url(${valid}) no-repeat 102% 50%`,
          backgroundSize: "2.6rem",
          boxShadow: "none",
        }
      : {};
    let boxShadow = isFocused && !isDisabled ? "0px 0px 5px rgba(97, 17, 106, 1)" : null;
    return {
      ...provider,
      display: "flex",
      width: "104%",
      borderRadius: 4,
      outline: "none",
      border: isDisabled ? "solid 1px #cccccc" : "solid 1px #dddddd",
      backgroundColor: isDisabled ? "#f5f5f5" : "#ffffff",
      boxShadow,
      opacity: isDisabled ? 0.6 : 1,
      cursor: isDisabled ? "not-allowed" : "pointer",
      pointerEvents: isDisabled ? "none" : "auto",
      ...border,
    };
  },
};
const Select = props => {
  const { name, label, options } = props;
  const [selected, setSelected] = useState({});
  const [opts, setOpts] = useState(options);

  const dispatch = useDispatch();
  const formObj = useSelector(({ form }) => form[form.currentForm], shallowEqual);
  const googleAddress = useSelector(({ app }) => app.googleAddress, shallowEqual);
  const isStateField = name === "state";
  const isCityField = name === "city";
  const isZipCodeField = name === "postalCode";
  const isCountyField = name === "county";

  const countrySelected = formObj && formObj.countryCode && (formObj.countryCode.value || formObj.countryCode);
  const stateSelected = formObj && formObj.state;
  const citySelected = formObj && formObj.city;
  const postalCode = formObj && formObj.postalCode;

  const isDisabledStateField = isStateField && countrySelected?.value === '';
  const isDisabledCityField = isCityField && stateSelected === '';
  const isDisabledPostalcodeField = isZipCodeField && citySelected === '';
  const isDisabledCountyField = isCountyField && postalCode === '';

  useEffect(() => {
    setOpts(options);
    if (options.length) {
      let _formVal = formObj && formObj.hasOwnProperty(name) ? formObj[name] : {};
      let actualVal = _formVal.value ? _formVal.value : _formVal;
      setSelected(() => {
        let _val = options.find(opt => opt.value === actualVal) || {};
        return _val;
      });
    }
  }, [options, formObj, name, googleAddress]);

  // useEffect(() => {
  //   let _val = formObj && formObj.hasOwnProperty(name) ? formObj[name] : {};
  //   setSelected(_val);
  // }, [name, formObj, dispatch]);

  const handleChange = selectedOption => {
    setSelected(selectedOption);
    dispatch(onSelectEvent(name, selectedOption));
  };
  return opts.length === 0 ? (
    <Input {...props} defaultValue={""} disabled={isDisabledStateField || isDisabledCityField || isDisabledPostalcodeField || isDisabledCountyField} placeholder={isDisabledStateField ? "Please select the Country to fill this field" : isDisabledCityField ? "Please select the State to fill this field" : isDisabledPostalcodeField ? "Please select the City to fill this field" : isDisabledCountyField ? "Please select the Postal Code to fill this field" : ""} />
  ) : (
    <div style={{ gridArea: name }}>
      <p className="sisp-label sisp-input--required">{label}</p>
      <ReSelect 
        defaultValue={selected} 
        value={selected} 
        styles={customStyles} 
        onChange={handleChange} 
        options={opts}
        isDisabled={isDisabledStateField || isDisabledCityField || isDisabledPostalcodeField || isDisabledCountyField}
      />
      {/* Hidden input is used for field validation */}
      <input 
        tabIndex={-1} 
        autoComplete="off" 
        defaultValue={selected.value || ""} 
        style={{ position: "absolute", visibility: "hidden" }} 
        required 
        minLength={3}
        disabled={isDisabledStateField || isDisabledCityField || isDisabledPostalcodeField || isDisabledCountyField}
      />
    </div>
  );
};

export default Select;
